import script from "./ThreeScene.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeScene.vue?vue&type=script&setup=true&lang=js"

import "./ThreeScene.vue?vue&type=style&index=0&id=6d597530&lang=css"

const __exports__ = script;

export default __exports__